import React from "react";
import { useState } from 'react';
import Clock from "../components/Clock";
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import Spinner from './spinner';
import { MsgExecuteContract, SyncTxBroadcastResult } from '@terra-money/terra.js';
import {
    createLCDClient,
    CreateTxFailed,
    SignResult,
    Timeout,
    TxFailed,
    TxUnspecifiedError,
    useConnectedWallet,
    UserDenied,
} from '@terra-money/wallet-provider';

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`;

const CONTRACT_ADDRESS = 'terra1s39qxezlsh3tdfqq0k8eyef6xchqfsntzp354c';
const MINT_COST = 1000000;

let imgsrc = "./img/items/seal.gif";

const Minting = function () {
    const connectedWallet = useConnectedWallet();
    const [showResults, setShowResults] = React.useState(0)
    async function mint() {
        setShowResults(1);
        if (!connectedWallet) {
            return;
        }

        // if (connectedWallet.network.chainID.startsWith('columbus')) {
        //     alert(`Please only execute this example on Testnet`);
        //     return;
        // }

        const terra = new createLCDClient({ network: connectedWallet.network });

        const executeMsg = {
            "mint_nft": {
                "owner": connectedWallet.terraAddress.toString(),
                "how_many": 1
            }
        }
        const execute = new MsgExecuteContract(
            connectedWallet.terraAddress, // sender
            CONTRACT_ADDRESS, // contract account address
            { ...executeMsg }, // handle msg
            { uluna: MINT_COST } // coins
        );

        const executeTx = await connectedWallet.sign({
            msgs: [execute]
        });

        terra.tx.broadcastSync(executeTx.result).then((result) => {
            new Promise(resolve => setTimeout(resolve, 20000)).then((_) => terra.tx.txInfo(result.txhash).then((txinfo) => {
                imgsrc = `https://merryterrachristmas.s3.ap-northeast-2.amazonaws.com/santa_seals/${txinfo.logs[0].events[3].attributes[3].value}.gif`;
                setShowResults(2);
            })
            )

        })
    }

    const [openMenu, setOpenMenu] = React.useState(true);
    const [openMenu1, setOpenMenu1] = React.useState(false);
    const handleBtnClick = (): void => {
        setOpenMenu(!openMenu);
        setOpenMenu1(false);
        document.getElementById("Mainbtn").classList.add("active");
        document.getElementById("Mainbtn1").classList.remove("active");
    };
    const handleBtnClick1 = (): void => {
        setOpenMenu1(!openMenu1);
        setOpenMenu(false);
        document.getElementById("Mainbtn1").classList.add("active");
        document.getElementById("Mainbtn").classList.remove("active");
    };
    return (
        <div>
            <GlobalStyles />

            <section className='container'>
                <div className='row mt-md-5 pt-md-4'>

                    <div className="col-md-5 text-center">
                        <h3>Your Santa will show here!</h3>
                        <p>(If you've finished minting, your Santa will appear here in 20 seconds. You can also check out your Santa on my collections page. Please wait a second.)</p>
                        {showResults == 1 && <Spinner/> }
                        {showResults == 2 && <img src={imgsrc} className="img-fluid img-rounded mb-sm-30" alt="" />}
                    </div>
                    <div className="col-md-6">
                        <div className="item_info">
                            Minting ends in
                            <div className="de_countdown">
                                <Clock deadline="January, 10, 2022" />
                            </div>
                            <h2>Merry Terra Christmas</h2>
                            <div className="item_info_counts">
                                <div className="item_info_type"><i className="fa fa-image"></i>Crypto Art</div>
                                {/* <div className="item_info_views"><i className="fa fa-eye"></i>Whitelist</div> */}
                                <div className="item_info_like"><i className="fa fa-heart"></i>Public Mint</div>
                            </div>
                            <p>Merry Terra Christmas Seals are 3,600+ randomely generated NFTs on the Terra blockchain.
                            It was the year 2021 and Christmas was just around the corner. LUNA was reaching new All-Time-Highs everyday and a surge of new NFT projects were being formed on Terra. 
                            Yet a group of LUNAtics and NFT manics couldn’t help feeling like something was missing.
                            It was Utility. For the NFT ecosystem in the terraverse to keep thriving, we must consider sustainability. We believe that a culture of giving back is key to a truly sustainable ecosystem. Through our Christmas Seals NFTs, We aim to start a virtuous cycle of growth with Angel Protocol. 
                            (Minting is only available on the desktop version.)
                            </p>
                           


                            <div className="skill-bar style-2">
                                <h4>Globally Minted</h4>
                                <h5>(1Luna for each Santa)</h5>
                                <div className="de-progress">
                                    <div className="progress-bar" style={{ width: `30%` }}>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 col-lg-10 mx-auto">
                                <br />
                                <div class="row">
                                    <div className="col-md-6 col-lg-6">
                                        <h3 class="pb-2" for="quantity">Quantity</h3>
                                        <input type="number" class="form-control input-rounded" min="1" step="1" max="4000" name="quantity" label="Quantity" placeholder="10" value="1" />

                                    </div>

                                    <div className="col-md-6 col-lg-6">
                                        <h3 class="pb-2" for="quantity">Currency</h3>
                                        <select name="currency" label="Currency" class="form-select input-rounded">
                                            <option value="LUNA">LUNA</option>
                                        </select>
                                        <br />
                                    </div>
                                </div>
                                <br />
                                <div class="col-md-6 col-lg-6 mx-auto mt-6"><button class="btn btn-dark rounded-pill w-100" onClick={() => mint()} disabled="">Mint</button></div>
                            </div>


                            <div className="spacer-40"></div>

                            <div className="de_tab">

                                {/* <ul className="de_nav">
                                    <li id='Mainbtn' className="active"><span onClick={handleBtnClick}>Bids</span></li>
                                    <li id='Mainbtn1' className=''><span onClick={handleBtnClick1}>History</span></li>
                                </ul>
                                 */}
                                {/* <div className="de_tab_content">
                                    {openMenu && (  
                                    <div className="tab-1 onStep fadeIn">
                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-1.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid accepted <b>0.005 ETH</b>
                                                <span>by <b>Monica Lucas</b> at 6/15/2021, 3:20 AM</span>
                                            </div>
                                        </div>

                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-2.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid <b>0.005 ETH</b>
                                                <span>by <b>Mamie Barnett</b> at 6/14/2021, 5:40 AM</span>
                                            </div>
                                        </div>

                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-3.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid <b>0.004 ETH</b>
                                                <span>by <b>Nicholas Daniels</b> at 6/13/2021, 5:03 AM</span>
                                            </div>
                                        </div>

                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-4.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid <b>0.003 ETH</b>
                                                <span>by <b>Lori Hart</b> at 6/12/2021, 12:57 AM</span>
                                            </div>
                                        </div>
                                    </div>
                                    )}

                                    {openMenu1 && ( 
                                    <div className="tab-2 onStep fadeIn">
                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-5.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid <b>0.005 ETH</b>
                                                <span>by <b>Jimmy Wright</b> at 6/14/2021, 6:40 AM</span>
                                            </div>
                                        </div>

                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-1.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid accepted <b>0.005 ETH</b>
                                                <span>by <b>Monica Lucas</b> at 6/15/2021, 3:20 AM</span>
                                            </div>
                                        </div>

                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-2.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid <b>0.005 ETH</b>
                                                <span>by <b>Mamie Barnett</b> at 6/14/2021, 5:40 AM</span>
                                            </div>
                                        </div>

                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-3.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid <b>0.004 ETH</b>
                                                <span>by <b>Nicholas Daniels</b> at 6/13/2021, 5:03 AM</span>
                                            </div>
                                        </div>

                                        <div className="p_list">
                                            <div className="p_list_pp">
                                                <span>
                                                    <img className="lazy" src="./img/author/author-4.jpg" alt=""/>
                                                    <i className="fa fa-check"></i>
                                                </span>
                                            </div>                                    
                                            <div className="p_list_info">
                                                Bid <b>0.003 ETH</b>
                                                <span>by <b>Lori Hart</b> at 6/12/2021, 12:57 AM</span>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    
                                </div> */}

                            </div>

                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </div>
    );
}
export default Minting;